export default "__VITE_ASSET__lujnVqu7__"